import { cva } from 'class-variance-authority'

/**
 * Stars rating variants
 *
 * Variante:
 * - default: Display-only stars
 * - interactive: Clickable stars for rating input
 */
export const starsContainerVariants = cva('flex items-center', {
  variants: {
    variant: {
      default: 'gap-0.5',
      interactive: 'gap-1',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export const starIconVariants = cva('fill-current transition-colors', {
  variants: {
    size: {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      default: 'h-6 w-6',
      lg: 'h-8 w-8',
      xl: 'h-12 w-12',
    },
    interactive: {
      true: 'cursor-pointer hover:scale-110 transition-transform',
      false: '',
    },
  },
  defaultVariants: {
    size: 'default',
    interactive: false,
  },
})
